import {InitPage} from "../index";

declare var itemsPath;
declare var selectedAlu;
declare var selectedName;

class OnHandInventory {

    constructor() {
        $(window).on('load',function(){
            if ($('.items-list').find("option[value='" + selectedAlu + "']").length) {
                $('.items-list').val(selectedAlu).trigger('change');
            } else {
                var newOption = new Option(selectedName, selectedAlu, true, true);
                $('.items-list').append(newOption).trigger('change');
            }
        })
    }

    initializeHTML() { 
        const _this = this;
        $('.items-list').select2({
            placeholder: 'Item # / Name',
            allowClear: true,
            width: '80%',
            ajax: {
                url: itemsPath
                },
            dropdownParent: $("#item-list"),
            templateSelection: _this.updateItemMetadata
          });
    }

    updateItemMetadata(e: any) {
        return e.text;
    }

}

declare global {
    interface Window {
        OnHandInventory: OnHandInventory;
    }
}

export function LoadPage() {
    InitPage("on_hand_inventory", () => {
        const on_hand_inventory = new OnHandInventory();
        window.OnHandInventory =  new OnHandInventory();
        window.OnHandInventory.initializeHTML();
    });
}
